/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { StringExtensions } from '@msdyn365-commerce-modules/retail-actions';
import * as React from 'react';

import Tooltip from './Tooltip';
import { IUncontrolledTooltipProps } from './Tooltip.props';

export interface IUncontrolledTooltipState {
    isOpen: boolean;
}

/**
 * UncontrolledTooltip examples.
 */
export default class UncontrolledTooltip extends React.PureComponent<IUncontrolledTooltipProps, IUncontrolledTooltipState> {
    private _isAutoDisplayTriggered: boolean;

    constructor(props: IUncontrolledTooltipProps) {
        super(props);
        this.state = { isOpen: false };
        this._toggle = this._toggle.bind(this);
        this._isAutoDisplayTriggered = false;
    }

    public render(): JSX.Element {
        const isCartPage = !StringExtensions.isNullOrWhitespace(this.props.cartPageUrl) &&
            window.location.toString().includes(this.props.cartPageUrl!);

        if (this.props.shouldShowMiniCart && !isCartPage) {
            if (!this._isAutoDisplayTriggered) {
                // First time trigger auto mini cart.
                this.setState({ isOpen: true });
                this._isAutoDisplayTriggered = true;
            } else if (!this.state.isOpen) {
                // If tooptip is closed, reset the flag.
                this._isAutoDisplayTriggered = false;
            }
        }

        return <Tooltip isOpen={this.state.isOpen} toggle={this._toggle} {...this.props} />;
    }

    private _toggle(): void {
        this.setState(previousState => ({ isOpen: !previousState.isOpen }));
    }
}
